import { useTranslation } from 'react-i18next';
import { useCatalogOptions } from '@/hooks/useCatalog.ts';
import type { CatalogContentBundle } from '@/types/catalog.ts';
import { TextField, BriefingField } from './BaseFields.tsx';

interface SubSectorFormProps {
  value: CatalogContentBundle;
  onChange: (next: CatalogContentBundle) => void;
  mode: 'create' | 'update';
}

export default function SubSectorForm({ value, onChange, mode }: SubSectorFormProps) {
  const { t } = useTranslation();
  const { options: parents } = useCatalogOptions('Sector');

  return (
    <div className="space-y-4">
      <TextField
        label={t('superuser.catalog.form.slug', { defaultValue: 'Slug' })}
        value={value.slug ?? ''}
        onChange={(v) => onChange({ ...value, slug: v })}
        readOnly={mode === 'update'}
        required={mode === 'create'}
        pattern="^[a-z0-9-]+$"
        hint={mode === 'create' ? 'lowercase + guiones' : undefined}
      />

      <div>
        <label className="mb-1.5 block text-sm font-medium text-foreground">
          {t('superuser.catalog.form.parentSlug', { defaultValue: 'Sector padre' })}
          <span className="ml-0.5 text-destructive">*</span>
        </label>
        <select
          value={value.parentSlug ?? ''}
          onChange={(e) => onChange({ ...value, parentSlug: e.target.value || null })}
          required
          className="w-full rounded-lg border border-border bg-card px-3 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
        >
          <option value="">—</option>
          {parents.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
      </div>

      <TextField
        label={t('superuser.catalog.form.label', { defaultValue: 'Etiqueta' })}
        value={value.label}
        onChange={(v) => onChange({ ...value, label: v })}
        required
      />
      <BriefingField
        value={value.briefing ?? ''}
        onChange={(v) => onChange({ ...value, briefing: v })}
      />
    </div>
  );
}
